<!-- Modal content-->
<div class="modal-content">
  <div class="card-block">
    <div class="modal-header">
      <a (click)="dismiss()">
        <img src="./assets/images/icon/btn-close.svg">
      </a>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <div class="col-md-12 text-center">
          <img [src]="iconImage" class="image-success">
          <h4 class="popup-title">{{title}}</h4>
          <h4 class="popup-message">{{message}}</h4>
        </div>
      </div>
    </div>
    <div class="modal-footer">

    </div>
  </div>
</div>